import { createContext, useContext } from 'react';
import { OrderGuideItemsContextType } from './item-context-types';

export const OrderGuideItemsContext =
  createContext<OrderGuideItemsContextType | null>(null);

export const useOrderGuideItemsContext = () => {
  const context = useContext(OrderGuideItemsContext);
  if (!context) {
    throw new Error(
      'useOrderGuideItemsContext requires a OrderGuideItemsContextProvider',
    );
  }

  return context;
};
